// extracted by mini-css-extract-plugin
export var combinationAdditional1 = "biochip-gyn-module--combination-additional-1--5ceSU";